import { render } from "./ExamInfoTab.vue?vue&type=template&id=40736408&scoped=true"
import script from "./ExamInfoTab.vue?vue&type=script&lang=js"
export * from "./ExamInfoTab.vue?vue&type=script&lang=js"

import "./ExamInfoTab.vue?vue&type=style&index=0&id=40736408&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40736408"]])

export default __exports__